import { FC, PropsWithChildren } from "react";

import { Button, MenuButton } from "capitalrx-components-2.0/lib/general";
import { SubmitButton, SubmitButtonProps } from "capitalrx-components-2.0/lib/forms";

import { styled } from "styled-components";

export const ThemedButton = styled(Button)`
  span {
    white-space: collapse;
  } 

  &.tertiary {
    color: ${(props) => props.theme?.primary_button_color};

    &:hover {
      color: ${(props) => props.theme?.primary_button_color};
    }

    path {
      fill: ${(props) => props.theme?.primary_button_color} !important;
    }

    &.disabled {
      color: ${(props) => props.theme?.primary_button_color} !important;
      cursor: not-allowed;
    }
    &:disabled {
      color: ${(props) => props.theme?.primary_button_color} !important;
      cursor: not-allowed;
    }

    &:active {
      color: ${(props) => props.theme?.primary_button_color} !important;
    }

    &.back-button {
      padding: 0;
      text-decoration: underline;

      .shelf {
        gap: 0.25rem;
        .semibold {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
        }
        .icon.size-regular {
          min-height: 1rem;
          max-height: 1rem;
          min-width: 1rem;
          max-width: 1rem;
        }
      }
    }
  }

  &.secondary {
    border-color: ${(props) => props.theme?.primary_button_color};
    color: ${(props) => props.theme?.primary_button_color};

    &:hover&:not(:disabled) {
      border-color: ${(props) => props.theme?.primary_button_color};
      color: ${(props) => props.theme?.primary_button_color};
      background-color: ${(props) => (props.theme?.primary_button_color)}1A;
    }

    path {
      fill: ${(props) => props.theme?.primary_button_color} !important;
    }

    &.disabled {
      border-color: ${(props) => props.theme?.primary_button_color} !important;
      opacity: 0.5;
      color: ${(props) => props.theme?.primary_button_color} !important;
    }
    &:disabled {
      border-color: ${(props) => props.theme?.primary_button_color} !important;
      opacity: 0.5;
      color: ${(props) => props.theme?.primary_button_color} !important;
    }
  }

  &.primary {
    border-color: ${(props) => props.theme?.primary_button_color};
    background-color: ${(props) => props.theme?.primary_button_color};
    &:hover {
      border-color: ${(props) => props.theme?.primary_button_color};
      background-color: ${(props) => props.theme?.primary_button_color};
    }

    &.disabled {
      background-color: ${(props) => props.theme?.primary_button_color} !important;
      border-color: ${(props) => props.theme?.primary_button_color} !important;
      opacity: 0.5;
    }
    &:disabled {
      background-color: ${(props) => props.theme?.primary_button_color} !important;
      border-color: ${(props) => props.theme?.primary_button_color} !important;
      opacity: 0.5;
    }
  }
`;

const _ThemedSubmitButtonWrapper = styled.div`

  > * {
    width: 100%;
  }

  span {
    white-space: collapse;
  }

  > .disabled {
    background-color: ${(props) => props.theme?.primary_button_color} !important;
    border-color: ${(props) => props.theme?.primary_button_color} !important;
    opacity: 0.5;
  }
  > :disabled {
    background-color: ${(props) => props.theme?.primary_button_color} !important;
    border-color: ${(props) => props.theme?.primary_button_color} !important;
    opacity: 0.5;
  }

  > .tertiary {
    color: ${(props) => props.theme?.primary_button_color};
    &:hover {
      color: ${(props) => props.theme?.primary_button_color};
    }

    path {
      fill: ${(props) => props.theme?.primary_button_color} !important;
    }
  }

  > .primary {
    border-color: ${(props) => props.theme?.primary_button_color};
    background-color: ${(props) => props.theme?.primary_button_color};
    &:hover,
    &:active {
      border-color: ${(props) => props.theme?.primary_button_color};
      background-color: ${(props) => props.theme?.primary_button_color};
    }
  }
`;

const _ThemedSubmitButton: FC<PropsWithChildren & SubmitButtonProps> = (props) => {
  return (
    <_ThemedSubmitButtonWrapper>
      <SubmitButton {...props}>{props.children}</SubmitButton>
    </_ThemedSubmitButtonWrapper>
  );
};

export const ThemedSubmitButton = _ThemedSubmitButton;

export const ThemedMenuButton = styled(MenuButton)`
  > button.primary, > button.primary.down {
    border-color: ${(props) => props.theme?.primary_button_color};
    background-color: ${(props) => props.theme?.primary_button_color};
    &:hover,
    &:active {
      border-color: ${(props) => props.theme?.primary_button_color};
      background-color: ${(props) => props.theme?.primary_button_color};
    }
  }

  > button.tertiary, button.tertiary.down {
    color: ${(props) => props.theme?.primary_button_color};
    &:hover {
      color: ${(props) => props.theme?.primary_button_color};
    }

    path {
      fill: ${(props) => props.theme?.primary_button_color};
    }
  }
`;
